import React, { useState } from 'react'
import classes from "./style.module.scss";

const ResourceDetails = (props) => {
    const { resourseInfo } = props
    return (
        <>
            <div className={`${classes.resourceCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-4'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>
                            Title
                        </div>
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.fullWidthInfoCategory}`}>
                            <div className={`${classes.infoLabel}`}>{resourseInfo?.title}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResourceDetails